// src/pages/NotFound.js
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const NotFound = () => {
  return (
    <section className="flex flex-col items-center justify-center min-h-screen bg-bnCream px-6 text-center">
      <motion.p
        className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Page Not Found
      </motion.p>
      <motion.h1
        className="font-display font-light text-bnInk leading-none text-7xl md:text-8xl"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        404
      </motion.h1>
      <motion.p
        className="text-bnBody text-base md:text-lg leading-relaxed mt-5 max-w-md"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        The page you are looking for does not exist or may have moved.
      </motion.p>
      <Link to="/" className="mt-8">
        <motion.span
          className="inline-flex items-center gap-2 bg-bnAccent hover:bg-bnAccentDark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
          whileHover={{ scale: 1.03 }}
        >
          Go Back Home
          <ArrowRight size={16} />
        </motion.span>
      </Link>
    </section>
  );
};

export default NotFound;
